
class wwStickyATC extends HTMLElement {
  constructor () {
    super()

    this.variantSelector = this.querySelector('select[name="id"]')
    this.mainVariantInput = document.querySelector('.product .product-form input[name="id"]')

    this.init()

    this.variantSelector?.addEventListener('change', (event) => {
      this.onVariantChange(event)
    })
    
    this.mainVariantInput.addEventListener('change', (event) => {
      this.onMainProductFormVariantChange(event)
    })
  }

  init () {
    const top = document.querySelector('.product product-form').getBoundingClientRect().bottom + window.scrollY

    window.addEventListener('scroll', () => {
      if (window.scrollY > top) {
        if (document.querySelector('.product .ww-sticky-atc')) {
          document.body.insertAdjacentElement('beforeend', this)
        }
        this.classList.add('show')
        document.body.style.paddingBottom = this.clientHeight + 'px'
      } else {
        this.classList.remove('show')
        document.body.style.paddingBottom = 0
      }
    })
  }

  onVariantChange (event) {
    event.preventDefault()
    const imgSrc = this.variantSelector.options[this.variantSelector.selectedIndex].dataset.variantImg

    if (imgSrc) {
      const img = this.variantSelector.closest('.ww-sticky-atc').querySelector('.ww-sticky-atc-img')
      img.src = imgSrc
    }
  }

  onMainProductFormVariantChange () {
    this.variantSelector.value = this.mainVariantInput.value
    this.variantSelector.dispatchEvent(new Event('change'))
  }
}
customElements.define('ww-sticky-atc', wwStickyATC)